<template>
  <div>
    <h4>Admissions Search</h4>
    <div class="form-group row">
      <div class="col-lg-4">
        <label>Search Patient / PRN</label>
        <input type="text"
               class="form-control"
               placeholder="Search PRN or Name"
               v-model="search_term">
      </div>
    </div>
    <div class='grid'>
      <grid-table
        v-if='results.length'
          :table-data='results'
          :options='culture_grid.options'
          :columns="culture_grid.columns">
        >
        <a
            slot='archives'
            slot-scope='props'
            v-bind:href="'/hmis-adapter/static/index.html?hospital_id=' + props.row.hospital_id">
          Archives</a>
      </grid-table>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import axios from 'axios'
import axiosConfig from '@/common/axiosConfig'
import CreateRouterMixin from '@/common/routerMixin'
import GridTable from '@/components/shared/datatable/Grid'

const getData = function (route) {
  return axios.get('hmis_functions/admissions/',
    Object.assign({ params: route.query }, axiosConfig)
  )
}

const routerMixin = CreateRouterMixin(getData)

export default {
  name: 'AdmissionsArchiveSearch',
  data () {
    return {
      search_term: '',
      results: [],
      result_count: 0,
      culture_grid: {
        options: {
          headings: {
          },
          dateColumns: ['admission_date']
        },
        columns: ['hospital_id', 'patient_name', 'admission_date', 'visit_no', 'archives']
      }
    }
  },
  mixins: [routerMixin],
  methods: {
    change_route (route) {
      this.$router.push(route)
    },
    setData (data) {
      this.results = data.results
      this.result_count = data.count
    }
  },
  created () {
    this.debouncedChangeRoute = _.debounce(this.change_route, 500)
  },
  watch: {
    search_term: function (newSearch, oldSearch) {
      const route = { name: this.$route.name, query: {} }

      // A number usually means hospital ID
      if (newSearch.match(/\d{4,10}/)) { route.query.hospital_id = newSearch }

      // search syntax
      if (newSearch.match(/[A-Za-z]{4,}/)) {
        route.query.search = newSearch
      }
      this.debouncedChangeRoute(route)
    }
  },
  components: {
    'grid-table': GridTable
  }
}
</script>
<style scoped>
.isolate_string:after {
  content: ', ';
}
.isolate_string:last-child:after {
  content: '';
}

</style>
